import * as React from 'react';

import styles from './styles.module.scss';

const LoadingTableContent: React.FC = () => {
	return (
		<div className={styles.loadingTableContainer}>
			<div className={styles.loadingTableContent}>
				<div className={styles.spinner} />
				Loading table content...
			</div>
		</div>
	);
};

export default React.memo(LoadingTableContent);
